// extracted by mini-css-extract-plugin
export default {"Previous":"PreviousButton_Previous__LTTx9","Danger":"PreviousButton_Danger__XmOWD"};